import { render, staticRenderFns } from "./DispatchHospitals.vue?vue&type=template&id=bdedfcc0&scoped=true&"
import script from "./DispatchHospitals.vue?vue&type=script&lang=js&"
export * from "./DispatchHospitals.vue?vue&type=script&lang=js&"
import style0 from "./DispatchHospitals.vue?vue&type=style&index=0&id=bdedfcc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdedfcc0",
  null
  
)

export default component.exports